import React from "react";
import { Card, CardBody } from "reactstrap";
import "boxicons/css/boxicons.min.css";

const TotalCard = ({ title="", value=0, icon="", color="orange" }) => (
  <Card className={`total-card ${color}`}>
    <CardBody>
      <div className="total-card-top">
        <div className="total-card-icon">
          {icon?.startsWith("bx") ? <i className={icon}></i> : icon}
        </div>
      </div>
      <p className="total-card-title">{title}</p>
      <h4 className="total-card-value">{value}</h4>
    </CardBody>
  </Card>
);


export default TotalCard;
